
































import { Action, Getter } from 'vuex-class';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import fetch from '@/common/api/fetch';
import CONFIG from '@/common/config';

import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { pickHtmlTextContent } from '@/common/utils/dealWithString';

import { exchangeMsgToXcx, wechatSignUp } from '@/common/utils/wechatFunc';
import { Ladder } from '@/common/interface/group_type';
import { ShareObjectInterface, SignatureData, AxiosPromiseData } from '@/common/interface';

import GroupActivitySection from '@/components/groupType/index/GroupActivitySection.vue';
import GroupingListModal from './GroupingListModal.vue';

@Component({
  components: {
    'group-activity-section': GroupActivitySection,
    'group-list-modal': GroupingListModal
  }
})
export default class CourseGroupingList extends Vue {
  @Prop() seqNo!: number;
  @Prop() courseName!: string;
   
  
  @Getter('title') title!: string;
  @Getter('section') section!: any;
  @Getter('gradientColor') gradientColor!: string;
  @Getter('mainTextColor') mainTextColor!: string;
  @Getter('groupList') groupList!: Array<object>;
  @Getter('urlUid') urlUid!: string;
  @Getter('coverTiny') coverTiny!: string;
  @Getter('signature') signature!: SignatureData;
  @Getter('courseGroupList') courseGroupList!: Ladder[];
  @Getter('courseType') courseType!: string;

  @Action('changeGroupList') changeGroupList!: Function;
  @Action('changeUrlUid') changeUrlUid!: Function;
  @Action('changeGroupNumber') changeGroupNumber!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  @Action('changeShowJoinFooter') changeShowJoinFooter!: Function;

  getUrlParam: Function = getUrlParam;
  showModal: boolean = false;
  totalCount: number = 0;
  showGroupList: any = [];
    
  mounted() {
    if (getUrlParam('type') === 'share') {
      this.getGroupingList();
    }
  }
  @Watch('courseType', { immediate: true, deep: true })
  onChangeValue(newVal: string, oldVal: string) {
    if (getUrlParam('type') === 'share' && newVal === 'MANY'&&oldVal==='ONE') {
      this.getGroupingList();
    }
  }
  getGroupingList() {
    const param: any = {
      activityId: getUrlParam('broadcastId'),
      pageNo: 0,
      pageSize: 10
    };
    if (this.courseType === 'MANY') {
      param.seqNo = this.seqNo
    }
    fetch.newpost('anon/group/getGroupingList', param).then((res: AxiosPromiseData) => {
      const { result = {} } = res;
      const { records = [], total = 0 } = result;
      // fix:防止多团情况下 第一个团重复渲染
      this.showGroupList = (this.courseType === 'ONE' || param.seqNo === this.seqNo) ? records : [];
    });
  }
  get filterGroupList(): Array<Object> {
    return this.groupList.filter((item: any) => item.groupDetailVOS[0].userId !== this.urlUid);
  }

  handleToggleMore() {
    this.showModal = !this.showModal;
    this.changeShowJoinFooter(!this.showModal);
  }

  // 去成团
  handleToOtherGroup(participatorId: string) {
    this.changeUrlUid(participatorId);
    const location = window.location.href.replace(/[?, &]code.*state/i, '').replace(/&uid=\d*/, '') + '&uid=' + participatorId;
    this.signatureWechatShare(location);
    exchangeMsgToXcx(participatorId);

    const parent:any = document.querySelector(`#app`)
    const child: any = document.querySelector(`#activityDeclare`)
    if (parent && child.offsetTop) {
      parent.scrollTo({
        top: child.offsetTop,//需要父元素设置postion(relative、absolute、fixed)
        behavior: "smooth"
      })
    }

  }

  signatureWechatShare(location: string) {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const shareObject: ShareObjectInterface = {
      title: this.title.replace(/<br\/>/g, '\n'),
      desc: pickHtmlTextContent(this.section.courseDesc),
      link:
        (CONFIG.shareUrl as any)[env] +
        (CONFIG.appId as any)[env] +
        '&redirect_uri=' +
        encodeURIComponent(location) +
        '&response_type=code&scope=' +
        (getActivityType() === 'groupType' ? 'snsapi_base' : 'snsapi_base') +
        '&state=state#wechat_redirect',
      imgUrl: this.coverTiny
    };
    wechatSignUp(this.signature, shareObject);
  }

  groupLadder(group: any) {
    /**
     * applyNum: 已经报名人数
     * 团的最小阶梯成团数
     * maxGroupSize: 满团人数
     */
    const { applyNum, groupSize, maxGroupSize  } = group;
    let status = '成团';
    let restSize = groupSize - applyNum;
    
    // maxGroupSize不存在说明不是阶梯拼团
    if (maxGroupSize) {
      // 已报名的人数大于等于第一个阶梯的成团数，说明已经成团了，但是没有满团
      if (applyNum >= Number(this.courseGroupList[this.seqNo - 1].ladderGroupList[0].groupSize)) {
        status = '满团';
        restSize = maxGroupSize - applyNum;
      } else {
        restSize = Number(this.courseGroupList[this.seqNo - 1].ladderGroupList[0].groupSize) - applyNum;
      }  
    }
    return {
      status,
      restSize
    };
  }
}
